var _excluded = ["variant", "amount", "showDetails", "brandSymbolProps", "brandType", "cardNumberProps", "cvvNumberProps", "expirationDateProps", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Group } from '../../../containers';
import { useBreakpointValue } from '../../../theme';
import { forwardRef, useTestId } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { BaseVirtualCard } from '../../internal/BaseVirtualCard';
import { Brand } from '../Brand';
import { BrandSymbol } from '../BrandSymbol';
import { Currency } from '../Currency';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VirtualCard = forwardRef((_ref, ref) => {
  var {
    variant,
    amount,
    showDetails,
    brandSymbolProps,
    brandType,
    cardNumberProps,
    cvvNumberProps,
    expirationDateProps,
    'data-testid': dataTestId = 'virtual-card'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('VirtualCard', {});
  var cardDetailsVariant = variant !== 'white' ? 'inverted' : 'default';
  var brandVariant = variant !== 'white' ? 'inverted' : 'neutral';
  var spacing = useBreakpointValue({
    xs: 'xxs',
    s: 's'
  });
  var getTestId = useTestId(dataTestId);
  return /*#__PURE__*/_jsx(BaseVirtualCard, _objectSpread(_objectSpread(_objectSpread({
    "data-component": "VirtualCard",
    ref: ref
  }, getTestId()), props), {}, {
    variant: variant,
    children: /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      height: "full",
      justifyContent: "space-evenly",
      spacing: spacing,
      children: [/*#__PURE__*/_jsxs(Group, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Currency, {
          amount: amount,
          variant: cardDetailsVariant
        }), /*#__PURE__*/_jsx(BrandSymbol, _objectSpread(_objectSpread({}, brandSymbolProps), {}, {
          size: "extra-large"
        }))]
      }), /*#__PURE__*/_jsx(BaseVirtualCard.CardNumber, _objectSpread(_objectSpread({}, cardNumberProps), {}, {
        showDetails: showDetails,
        variant: cardDetailsVariant
      }, getTestId('card-number'))), /*#__PURE__*/_jsxs(Group, {
        justifyContent: "space-between",
        alignItems: "flex-end",
        children: [/*#__PURE__*/_jsxs(Group, {
          spacing: "m",
          children: [/*#__PURE__*/_jsx(BaseVirtualCard.ExpirationDate, _objectSpread(_objectSpread({}, expirationDateProps), {}, {
            showDetails: showDetails,
            variant: cardDetailsVariant
          }, getTestId('expiration-date'))), /*#__PURE__*/_jsx(BaseVirtualCard.CvvNumber, _objectSpread(_objectSpread({}, cvvNumberProps), {}, {
            showDetails: showDetails,
            variant: cardDetailsVariant
          }, getTestId('cvv-number')))]
        }), /*#__PURE__*/_jsx(Box, {
          __css: styles['brand'],
          children: /*#__PURE__*/_jsx(Brand, {
            type: brandType,
            variant: brandVariant
          })
        })]
      })]
    })
  }));
});
VirtualCard.displayName = 'VirtualCard';
//# sourceMappingURL=VirtualCard.js.map